export const LogoMark = ({ size = 34 }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" fill="none" aria-hidden="true">
    <defs>
      <linearGradient id="lg" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#00F0FF" />
        <stop offset="1" stopColor="#3B82F6" />
      </linearGradient>
    </defs>
    <rect x="2" y="2" width="60" height="60" rx="16" fill="#05070A" stroke="url(#lg)" strokeWidth="3" />
    <path d="M35.5 12 L22 34.5 H31 L28.5 52 L44 27.5 H34.5 L37.5 12 Z" fill="url(#lg)" />
    <path d="M14 46 l8 -5" stroke="#00F0FF" strokeWidth="3" strokeLinecap="round" opacity="0.55" />
  </svg>
);

export const Logo = ({ size = 34 }) => (
  <span className="flex items-center gap-2.5">
    <LogoMark size={size} />
    <span className="font-display text-2xl font-extrabold uppercase tracking-tight leading-none">
      MAX<span className="text-neon">REVIX</span>
    </span>
  </span>
);
